import { Box, Button, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";

import axios from "axios";
import { toast } from "react-toastify";

import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { _get,_put } from "../utils/apiServices";

const validationSchema = yup.object({
  name: yup.string("Add Name Field").required("Name Field is required"),
  placeholder: yup
    .string("Add placeholder")
    .required("Placeholder is required"),
  namePdf: yup
    .string("Insert the name of the field inside the pdf documents")
    .required("The namePdf is required"),
});

const EditField = () => {
  const { id } = useParams();
  const [name, setName] = useState("");
  const [placeholder, setPlaceholder] = useState("");
  const [namePdf, setNamePdf] = useState("");

  const navigate = useNavigate();

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: {
        name,
        placeholder,
        namePdf,
      },

      validationSchema: validationSchema,
      enableReinitialize: true,
      onSubmit: (values, actions) => {
        updateField(values);
        //alert(JSON.stringify(values, null, 2));
        actions.resetForm();
      },
    });

  //show post by Id
  const singleFieldById = async () => {
    // console.log(id)
    try {
      const { data } = await _get(`/api/field/${id}`);
      setName(data.field.title);
      setPlaceholder(data.field.placeholder);
      setNamePdf(data.field.namePdf);
      console.log("single field admin", data.post);
    } catch (error) {
      console.log(error);
      toast.error(error);
    }
  };

  const updateField = async (values) => {
    try {
      const { data } = await _put(
        `/api/update/field/${id}`,
        values
      );
      if (data.success === true) {
        toast.success("field updated");
        navigate("/admin/field/dashboard");
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.error);
    }
  };

  return (
    <>
      <Box sx={{ bgcolor: "white", padding: "20px 200px" }}>
        <Typography variant="h5" sx={{ pb: 4 }}>
          {" "}
          Create post{" "}
        </Typography>
        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <TextField
            sx={{ mb: 3 }}
            fullWidth
            id="name"
            label="Field name"
            name="name"
            InputLabelProps={{
              shrink: true,
            }}
            placeholder="Field Name"
            value={values.title}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.title && Boolean(errors.title)}
            helperText={touched.title && errors.title}
          />
          <TextField
            sx={{ mb: 3 }}
            fullWidth
            id="placeholder"
            label="Placeholder"
            name="placeholder"
            InputLabelProps={{
              shrink: true,
            }}
            placeholder="Insert the placeholder that will be shown in the homepage"
            value={values.title}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.title && Boolean(errors.title)}
            helperText={touched.title && errors.title}
          />
          <TextField
            sx={{ mb: 3 }}
            fullWidth
            id="namePdf"
            label="namePdf"
            name="namePdf"
            InputLabelProps={{
              shrink: true,
            }}
            placeholder="namePdf"
            value={values.title}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.title && Boolean(errors.title)}
            helperText={touched.title && errors.title}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            elevation={0}
            sx={{ mt: 3, p: 1, mb: 2, borderRadius: "25px" }}
          >
            Edit Field
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default EditField;
